import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const entroSecurity = defineConnector({
  identifier: "entroSecurity",
  name: "Entro Security",
  tagLine: "Secrets security posture management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ apiEndpointUrl }) => domainToRegex(apiEndpointUrl),
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Generate an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In the Entro platform, go to **Settings → API keys** and click **Generate new token**. Fill in the details and click **Generate New Token**. Copy the token from the confirmation window.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
    {
      title: "Enter your API endpoint URL",
      items: [
        {
          kind: "url",
          label: "API endpoint URL",
          placeholder: "https://api.entro.security",
          required: true,
          target: { kind: "configuration", field: "apiEndpointUrl" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiEndpointUrl }) => `${apiEndpointUrl}/api/v1/status`,
  },
});
